/** Namespace `sources` — bản gốc tiếng Việt. Khoá phẳng, tên camelCase; `{biến}` để chèn. */
export const sources = {
  title: "Nguồn dữ liệu",
  subtitle: "Hub đọc chỉ-đọc từ cơ sở dữ liệu của từng app. « Chưa cấu hình » không phải sự cố.",
  loadListFailed: "Không đọc được danh sách nguồn.",
  deduplicated: "Đang có lượt quét chạy rồi — theo dõi lượt đó.",
  queued: "Đã xếp hàng.",
  serverUnreachable: "Không gọi được máy chủ.",
  viewRun: "Xem lượt chạy",
  emptyTitle: "Chưa có nguồn nào được khai.",
  emptyBefore: "Worker khai danh sách nguồn lúc khởi động. Xem ",
  emptyAfter: " §3 để cấp quyền chỉ-đọc cho từng cơ sở dữ liệu.",
  lastRun: "Quét lần cuối {time}",
  neverRun: "Chưa quét lần nào",
  driftColumns: "Cột lệch:",
  unsupportedCount: "Không hỗ trợ {count} mảng",
  queueing: "Đang xếp hàng…",
  refreshNow: "Làm mới ngay",

  loadDetailFailed: "Không đọc được chi tiết nguồn.",
  detailMeta: "{kind} · {status} · adapter {adapter} · hợp đồng {contract}",
  dsnBefore: "Chuỗi kết nối đọc từ biến ",
  dsnAfter: " — chỉ tiến trình worker giữ nó.",
  driftTitle: "Lệch schema — hub đã NGỪNG lấy số từ luồng này.",
  driftBefore: "Con trỏ ",
  driftStrong: "không tiến",
  driftAfter: ", nên khi connector được sửa, lượt chạy sau tự bắt kịp cửa sổ đã bỏ lỡ.",
  streams: "Luồng",
  "col.stream": "Luồng",
  "col.capability": "Khái niệm",
  "col.fingerprint": "Vân tay",
  "col.watermark": "Đọc tới",
  "col.lastSuccess": "Thành công cuối",
  "col.safetyWindow": "Cửa sổ an toàn",
  notChecked: "chưa kiểm",
  metricBases: "Cơ sở đo",
  unsupportedTitle: "Nguồn này không đo được",
  recentRuns: "20 lượt chạy gần nhất",
  "col.result": "Kết quả",
  "col.rows": "Số dòng",
  "col.requested": "Xếp hàng",
  "col.finished": "Xong",
  noRuns: "Chưa chạy lần nào.",
} as const;
